import React, { useEffect, useState } from 'react';
import { Gift, Copy, Check, Share2, Users } from 'lucide-react';
import { toast } from 'sonner';
import { useClientAuth } from '../../context/ClientAuthContext';

/** Programme de parrainage : lien personnel à partager, 1 mois offert pour le parrain ET
 * le filleul dès son 1er paiement coaching. */
export const ReferralCard = ({ en }) => {
  const L = (fr, eng) => (en ? eng : fr);
  const { authFetch } = useClientAuth();
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    authFetch('/api/tracking/referral').then((r) => r.json()).then(setData).catch(() => {});
  }, [authFetch]);

  if (!data) return null;

  const copyLink = () => {
    navigator.clipboard.writeText(data.referral_link).then(() => {
      setCopied(true);
      toast.success(L('Lien copié !', 'Link copied!'));
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const share = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Body-Up',
        text: L('Rejoins-moi sur Body-Up et profite de 1 mois offert !', 'Join me on Body-Up and get 1 month free!'),
        url: data.referral_link,
      }).catch(() => {});
    } else {
      copyLink();
    }
  };

  return (
    <div className="rounded-2xl border border-primary/25 bg-gradient-to-br from-primary/10 via-zinc-900 to-black p-5" data-testid="referral-card">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary to-pink-500 flex items-center justify-center shrink-0">
          <Gift className="w-5 h-5 text-white" />
        </div>
        <div>
          <p className="font-black text-white text-base">{L('Programme de parrainage', 'Referral program')}</p>
          <p className="text-xs text-zinc-400">{L(`Invitez un ami, débloquez ${data.reward_label} chacun`, `Invite a friend, unlock ${data.reward_label === '1 mois offert' ? '1 free month' : data.reward_label} each`)}</p>
        </div>
      </div>

      <div className="mt-4 flex items-stretch gap-2">
        <div className="flex-1 min-w-0 rounded-xl bg-black/40 border border-white/10 px-3 py-2.5 flex items-center" data-testid="referral-link-display">
          <span className="text-xs text-zinc-300 truncate font-mono">{data.referral_link}</span>
        </div>
        <button
          onClick={copyLink}
          className="shrink-0 w-11 rounded-xl bg-white/5 border border-white/10 hover:border-primary/40 flex items-center justify-center text-zinc-300 hover:text-white transition-colors"
          data-testid="referral-copy-btn"
        >
          {copied ? <Check className="w-4 h-4 text-emerald-400" /> : <Copy className="w-4 h-4" />}
        </button>
        <button
          onClick={share}
          className="shrink-0 w-11 rounded-xl bg-gradient-to-br from-primary to-pink-500 flex items-center justify-center text-white"
          data-testid="referral-share-btn"
        >
          <Share2 className="w-4 h-4" />
        </button>
      </div>

      {data.rewards_earned > 0 && (
        <div className="mt-4 pt-4 border-t border-white/10">
          <p className="text-[10px] uppercase tracking-widest text-zinc-500 font-bold mb-2 flex items-center gap-1.5">
            <Users className="w-3.5 h-3.5" /> {L(`${data.rewards_earned} récompense(s) débloquée(s)`, `${data.rewards_earned} reward(s) unlocked`)}
          </p>
          <div className="space-y-1.5">
            {data.referrals.map((r, i) => (
              <div key={i} className="flex items-center justify-between text-xs" data-testid={`referral-history-row-${i}`}>
                <span className="text-zinc-400">{r.referee_email_masked}</span>
                <span className="text-emerald-400 font-semibold">{L('1 mois offert débloqué', '1 free month unlocked')}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferralCard;
